/* eslint semi: 1 */
import _ from 'lodash';

/**
 * Permission to Create Style
 * All users can create style, except for those with exclusive `Modify/user_create_lock` rights.
 */
export const hasPermissionToCreateStyle = (currentUser) => {
  let res = true;

  if (_.isEmpty(currentUser)) {
    return false;
  }

  if (currentUser.hasGroupUserCreateLock() && !currentUser.hasGroupUserCreate()) {
    res = false;
  } else if (!currentUser.hasGroupUserCreate() && currentUser.hasGroupUserSchedule()) {
    res = false;
  } else if (!currentUser.hasGroupUserCreate() && currentUser.hasGroupUserPlayer()) {
    res = false;
  } else if (!currentUser.hasGroupUserCreate() && currentUser.hasGroupUserAlert()) {
    res = false;
  }

  return res;
};
